interface StepHeadingProps {
  title: string;
  description?: string;
}

/**
 * Cabeçalho padrão de uma etapa do wizard (título + descrição opcional).
 * Mantém consistência tipográfica entre os passos.
 */
export function StepHeading({ title, description }: StepHeadingProps) {
  return (
    <div className="space-y-1">
      <h2 className="text-lg font-semibold">{title}</h2>
      {description ? (
        <p className="text-sm text-muted-foreground">{description}</p>
      ) : null}
    </div>
  );
}
